import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import { IRoute } from "../../common/typings/routes";
import { Main } from "./HeadQuarter";
import { Insights } from "./pages/insights";
import { CameraStream } from "./pages/camera";
import { Settings } from "./pages/settings";

export const HeadQuarterRoute: IRoute = {
  title: "HQ Dashboard",
  path: "/hq",
  icon: HomeIcon,
  component: Main,
  guard: true,
  subRoutes: [
    { icon: InfoIcon, component: Insights, path: "/insights", title: "Insights" },
    { icon: InfoIcon, component: CameraStream, path: "/stream", title: "Camera Stream" },
    { icon: InfoIcon, component: Settings, path: "/settings", title: "Settings" },
  ],
};
